var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1.53125C4.61617 1.53125 3.75218 1.79334 3.0173 2.28437C2.28242 2.7754 1.70964 3.47333 1.37142 4.28988C1.03319 5.10644 0.94469 6.00496 1.11712 6.87181C1.28955 7.73866 1.71515 8.53492 2.34012 9.15988C2.96508 9.78485 3.76134 10.2105 4.62819 10.3829C5.49504 10.5553 6.39356 10.4668 7.21012 10.1286C8.02668 9.79036 8.7246 9.21759 9.21563 8.4827C9.70667 7.74782 9.96875 6.88384 9.96875 6C9.96648 4.81551 9.49494 3.68019 8.65738 2.84263C7.81981 2.00506 6.68449 1.53352 5.5 1.53125ZM7.90625 6.34375H5.5C5.40883 6.34375 5.3214 6.30753 5.25693 6.24307C5.19247 6.1786 5.15625 6.09117 5.15625 6V3.59375C5.15625 3.50258 5.19247 3.41515 5.25693 3.35068C5.3214 3.28622 5.40883 3.25 5.5 3.25C5.59117 3.25 5.6786 3.28622 5.74307 3.35068C5.80754 3.41515 5.84375 3.50258 5.84375 3.59375V5.65625H7.90625C7.99742 5.65625 8.08485 5.69247 8.14932 5.75693C8.21379 5.8214 8.25 5.90883 8.25 6C8.25 6.09117 8.21379 6.1786 8.14932 6.24307C8.08485 6.30753 7.99742 6.34375 7.90625 6.34375Z",
    fill: "#D7C0FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.4795efeb0d12648403a7230cb0c9a614.svg";
export { ForwardRef as ReactComponent };